import { useFilter } from '@/hooks/filter';
import { ScreenFiltersData } from '@/hooks/interfaces/filter';
import React, { useCallback, useEffect, useState } from 'react';

import FilterItem from './components/FilterItem';
import { FiltersProps } from './interfaces';
import { Container } from './styles';

const RowView: React.FC<FiltersProps> = ({
  screen,
  onSubmit,
  onFiltersLoaded,
  initialFilters,
  getFormattedFilter,
}) => {
  const [filters, setFilters] = useState<ScreenFiltersData>([]);
  const {
    getFilters,
    getQueryString,
    getSelectedOptions,
    clearFilter,
  } = useFilter();

  useEffect(() => {
    getFilters(screen, initialFilters).then((filters) => {
      if (filters.length > 0) {
        setFilters(filters);
      }
      if (onFiltersLoaded) {
        onFiltersLoaded();
      }
    });
  }, [getFilters, screen, initialFilters, onFiltersLoaded]);

  const onFilter = useCallback(() => {
    const query = getQueryString();
    onSubmit(query);

    const options = getSelectedOptions();
    getFormattedFilter(options);
  }, [getQueryString, onSubmit, getFormattedFilter, getSelectedOptions]);

  const handleClearFilter = (column: string | undefined) => {
    clearFilter(column);
    onFilter();
  };

  return (
    <Container>
      {filters.map((filter) => {
        const initialFilter =
          initialFilters &&
          initialFilters.find(
            (item) =>
              item.column === filter.column && item.type === filter.type,
          );

        return (
          <React.Fragment key={filter.column + filter.type}>
            <FilterItem
              {...filter}
              initialFilter={initialFilter || {}}
              onClearFilter={handleClearFilter}
              isModeView
              key={filter.column + filter.type}
            />
          </React.Fragment>
        );
      })}
    </Container>
  );
};

export default RowView;
